import { render, staticRenderFns } from "./activityGoal.vue?vue&type=template&id=75f4e970"
import script from "./activityGoal.vue?vue&type=script&lang=js"
export * from "./activityGoal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports